<div class="promotions-page">
    <div class="promo-header">
        <h2>Special offer for you</h2>
    </div>

    <div class="main-promo-card">
        <img src="{{club?.img_path}}" alt="Promotion" class="promo-image">
        
        <div class="purple-cloud">
            <h4 class="promo-title">Purple Hours</h4>
            <p class="promo-text">Get a highest discounts in purple hours</p>
        </div>
        
        <div class="transparent-cloud">
            <p>During the interval 13:00-14:00 your match will cost you 3.000 rsd</p>
        </div>
        
        <div class="blue-cloud">
            <p style="margin-top: 25px;">Click use gift to get a special discount for your padel match.</p>
            <button class="use-gift-btn">Use gift</button>
        </div>
    </div>

 <div class="gifts-section">
        <div class="promo-header">
        <h2>Gifts</h2>
        </div>
    <div class="gift-cards-container">
            <div class="gift-card">
                <img src="assets/images/gifts-1.png" alt="Gift 1" class="gift-image">
                <div class="gift-text">
                    <p>You can get a free aqua viva sports drink</p>
                </div>
                <div class="blue-cloud" id="blue-cloud2">
                    <p style="font-size: 14px;">Click use gift to get a special discount for your padel match.</p>
                    <button class="use-gift-btn">Use gift</button>
                </div>
            </div>
            
            <div class="gift-card">
                <img src="assets/images/gifts-2.png" alt="Gift 2" class="gift-image">
                <div class="gift-text">

                    <p>In your next match you can use our rackets for free</p>
                </div>
                <div class="blue-cloud" id="blue-cloud2">
                    <p style="font-size: 14px;">Click use gift to get a special discout for your padel match.</p>
                    <button class="use-gift-btn">Use gift</button>
                </div>
            </div>
        </div>
    </div>
</div>